import React, { useState, useEffect, useRef } from "react";
import { PageTokenUsage } from "./pages/PageTokenUsage.js";
import { Login } from "./pages/Login.js";
import { TrendChart } from "./pages/TrendChart.js";
import { PageDashboard } from "./pages/PageDashboard.js";
import { PageVulns } from "./pages/PageVulns.js";
import { PageCampaigns } from "./pages/PageCampaigns.js";
import { PageRemediation } from "./pages/PageRemediation.js";
import { PageExceptions } from "./pages/PageExceptions.js";
import { PageAssets } from "./pages/PageAssets.js";
import { PageCompliance } from "./pages/PageCompliance.js";
import { PageEOL, EOLLeadershipCard } from "./pages/PageEOL.js";
import { PageLeadership } from "./pages/PageLeadership.js";
import { PageAIAgent } from "./pages/PageAIAgent.js";
import { PageIntegrations } from "./pages/PageIntegrations.js";
import { PageSettings } from "./pages/PageSettings.js";
import { PageChangePass } from "./pages/PageChangePass.js";
import { PageUserMgmt } from "./pages/PageUserMgmt.js";
import { PagePodMgmt } from "./pages/PagePodMgmt.js";
import { PageAuditLog } from "./pages/PageAuditLog.js";
import { PageAPIConfig } from "./pages/PageAPIConfig.js";
import { PageHealth } from "./pages/PageHealth.js";
import { PageAttackPath } from "./pages/PageAttackPath.js";
import { PageAgentStatus } from "./pages/PageAgentStatus.js";
import { PageNotifSchedule } from "./pages/PageNotifSchedule.js";
import { EmailLogsTab } from "./pages/EmailLogsTab.js";
import { PageTemplates } from "./pages/PageTemplates.js";
import { PageDedup } from "./pages/PageDedup.js";
import { PageAIConfig } from "./pages/PageAIConfig.js";
import { api, ThemeCtx, ToastCtx, SEV_C, STAT_C, PAGE_SIZE, Pager, Card, Modal, Bdg, Dot, Av, AdminBadge, useToast, ConfirmDialog, usePagination, ToastProvider, ToastContainer } from "./shared.js";
import { LayoutDashboard, Shield, ShieldAlert, CalendarCheck, ClipboardList,
  Monitor, CheckSquare, AlertTriangle, Link2, Settings, Lock, GitMerge,
  Users, Building2, FileText, Bot, RefreshCw, Upload, Download,
  AlertCircle, Bell, Key, Activity, Eye, Trash2, Edit2, Plus,
  ChevronDown, ChevronUp, Search, Filter, X, Check, Info,
  BarChart2, PieChart, TrendingUp, Clock, Zap, Database,
  Server, Cloud, Package, Code, Globe, Cpu, HardDrive, Network } from "lucide-react";

// Lucide icon helper — renders icon with consistent sizing
var Icon = function(props) {
  var name = props.name;
  var size = props.size || 15;
  var color = props.color || "currentColor";
  var style = props.style || {};
  var icons = {
    LayoutDashboard, Shield, ShieldAlert, CalendarCheck, ClipboardList,
    Monitor, CheckSquare, AlertTriangle, Link2, Settings, Lock, GitMerge,
    Users, Building2, FileText, Bot, RefreshCw, Upload, Download,
    AlertCircle, Bell, Key, Activity, Eye, Trash2, Edit2, Plus,
    BarChart2, PieChart, TrendingUp, Clock, Zap, Database,
    Server, Cloud, Package, Code, Globe, Cpu, HardDrive, Network
  };
  var Comp = icons[name];
  if (!Comp) return React.createElement("span", {style:{width:size,height:size,display:"inline-block"}});
  return React.createElement(Comp, {size:size, color:color, style:Object.assign({flexShrink:0,display:"block"},style)});
};

// ── Environment ───────────────────────────────────────────────────────────────
// Demo mode permanently disabled — production only
var API_BASE = process.env.REACT_APP_API_URL || "/api";
var APP_NAME = process.env.REACT_APP_NAME || "AVTA";

// ── Themes ────────────────────────────────────────────────────────────────────
var THEMES = {
  dark: {
    bg:"#0b0f1a", sidebar:"#111827", card:"#111827", border:"#1e2d45",
    text:"#e2e8f0", text2:"#8899b4", text3:"#4d6280",
    accent:"#3b82f6", accentBg:"rgba(59,130,246,0.1)", inset:"#1a2233",
    success:"#10b981", warning:"#f59e0b", danger:"#ef4444", info:"#06b6d4",
    shadow:"rgba(0,0,0,0.5)",
    cardShadow:"0 1px 3px rgba(0,0,0,0.4), 0 1px 2px rgba(0,0,0,0.3)",
    pill:"#2a3f5f",
    border2:"#2a3f5f", s2:"#1a2233", s3:"#212d42",
  },
  light: {
    bg:"#f8fafc", sidebar:"#ffffff", card:"#ffffff", border:"#cbd5e1",
    text:"#0f172a", text2:"#475569", text3:"#94a3b8",
    accent:"#2563eb", accentBg:"rgba(37,99,235,0.08)", inset:"#f1f5f9",
    success:"#059669", warning:"#d97706", danger:"#dc2626", info:"#0891b2",
    shadow:"rgba(15,23,42,0.06)",
    cardShadow:"0 1px 3px rgba(15,23,42,0.08), 0 1px 2px rgba(15,23,42,0.04)",
    pill:"#e2e8f0",
    border2:"#94a3b8", s2:"#f1f5f9", s3:"#e2e8f0",
  },
};
export default function App(){
  var _user=useState(null); var user=_user[0]; var setUser=_user[1];
  var _page=useState("leadership"); var page=_page[0]; var setPage=_page[1];
  var _sel=useState(null); var selVuln=_sel[0]; var setSelVuln=_sel[1];
  var _col=useState(false); var collapsed=_col[0]; var setCollapsed=_col[1];
  var _vulns=useState([]); var vulns=_vulns[0]; var setVulns=_vulns[1];
  var _load=useState(true); var loading=_load[0]; var setLoading=_load[1];
  var _err=useState(null); var appErr=_err[0]; var setAppErr=_err[1];
  var _bulk=useState(false); var bulkOpen=_bulk[0]; var setBulkOpen=_bulk[1];
  var _exp=useState(false); var exportOpen=_exp[0]; var setExportOpen=_exp[1];
  var _nv=useState(false); var newVulnOpen=_nv[0]; var setNewVulnOpen=_nv[1];
  var _tn=useState("light"); var themeName=_tn[0]; var setThemeName=_tn[1];
  var T = THEMES[themeName]||THEMES.dark;
  var toggle = function(){ setThemeName(function(n){return n==="dark"?"light":"dark";}); };

  useEffect(function(){
    if(!user){
      if(api.hasRefreshToken()){
        (async function(){
          try{
            var r=await fetch("/api/auth/refresh",{
              method:"POST",
              headers:{"Content-Type":"application/json"},
              body:JSON.stringify({refresh_token:api.getRefreshToken()})
            });
            if(r.ok){
              var d=await r.json();
              api.setTokens(d.access_token,d.refresh_token);
              var me=await api.get("/auth/me");
              if(me&&me.id){
                me.avatar=(me.name||"?").split(" ").map(function(x){return x[0];}).join("").slice(0,2);
                setUser(me);
                return;
              }
            }
          }catch(e){ void e; }
          setLoading(false);
        })();
      } else { setLoading(false); }
      return;
    }
    (async function(){
      try{
      var data=await api.get("/vulns");
      try{
        var dups=await api.get("/dedup/findings?status=pending");
        var dupMap={};
        (dups.findings||[]).forEach(function(f){dupMap[f.primary_vuln_id]=(dupMap[f.primary_vuln_id]||0)+1;dupMap[f.duplicate_vuln_id]=(dupMap[f.duplicate_vuln_id]||0)+1;});
        data=data.map(function(v){return Object.assign({},v,{_dupCount:dupMap[v.id]||0});});
      }catch(e){ void e; }
      setVulns(data);
    }
      catch(e){ setAppErr("Failed to load vulnerabilities: "+e.message); }
      setLoading(false);
    })();
  },[user]);

  var logout = async function(){
    try{ await api.post("/auth/logout",{refresh_token:localStorage.getItem("avta_refresh")}); } catch(e){ void e; }
    api.clearTokens(); setUser(null); setVulns([]);
  };
  var addVuln = async function(v){
    try{ var n=await api.post("/vulns",v); setVulns(function(p){return [n].concat(p);}); }
    catch(e){ void e; setVulns(function(p){return [Object.assign({},v,{id:"VUL-"+String(p.length+1).padStart(3,"0"),days_left:v.sla_days})].concat(p);}); }
  };
  var refreshVulns = async function(){
    try{ var data=await api.get("/vulns"); setVulns(data); }
    catch(e){ void e; }
  };
  var updateVuln = async function(u){
    try{ await api.patch("/vulns/"+u.id,{status:u.status}); } catch(e){ void e; }
    setVulns(function(p){return p.map(function(v){return v.id===u.id?u:v;});});
  };

  if(!user) return React.createElement(ThemeCtx.Provider,{value:{T:T,name:themeName,toggle:toggle}},React.createElement(Login,{onLogin:function(u){setUser(u);setPage("leadership");},theme:T}));

  if(appErr) return React.createElement("div",{style:{minHeight:"100vh",background:T.bg,display:"flex",alignItems:"center",justifyContent:"center",fontFamily:"system-ui,sans-serif",padding:16}},
    React.createElement("div",{style:{background:T.card,border:"1px solid "+T.danger+"66",borderRadius:14,padding:"36px 32px",width:"100%",maxWidth:420,textAlign:"center"}},
      React.createElement("div",{style:{fontSize:36,marginBottom:16}},"\u26A0\uFE0F"),
      React.createElement("div",{style:{fontSize:18,fontWeight:700,color:T.danger,marginBottom:8}},"Connection Error"),
      React.createElement("div",{style:{fontSize:13,color:T.text2,marginBottom:20,lineHeight:1.6}},appErr),
      React.createElement("div",{style:{background:T.inset,borderRadius:8,padding:"12px 14px",fontSize:12,color:T.text3,marginBottom:20,textAlign:"left"}},
        React.createElement("div",{style:{fontWeight:600,color:T.text2,marginBottom:6}},"Troubleshooting:"),
        React.createElement("div",null,"1. ",React.createElement("code",{style:{color:T.accent}},"docker compose ps")),
        React.createElement("div",{style:{marginTop:4}},"2. ",React.createElement("code",{style:{color:T.accent}},"docker compose logs server")),
        React.createElement("div",{style:{marginTop:4}},"3. ",React.createElement("code",{style:{color:T.accent}},"curl http://localhost:8080/api/health"))
      ),
      React.createElement("button",{onClick:function(){setAppErr(null);setLoading(true);setUser(null);},style:{background:T.accent,color:"#fff",border:"none",borderRadius:8,padding:"10px 24px",cursor:"pointer",fontSize:13,fontWeight:600}},"\u2190 Back to Login")
    )
  );

  if(loading) return React.createElement("div",{style:{minHeight:"100vh",background:T.bg,display:"flex",alignItems:"center",justifyContent:"center",color:T.text3,fontFamily:"system-ui,sans-serif",gap:10}},React.createElement("span",{style:{fontSize:20}},"\uD83D\uDEE1")," Loading "+APP_NAME+"...");

  var can=function(f){
    if(user.role==="admin") return true;
    if(["aiagent","health","agentstatus","integrations"].indexOf(f)!==-1) return false;
    if(f==="bulkupload"&&user.role==="owner") return false;
    return true;
  };
  var myVulns = user.role==="owner" ? vulns.filter(function(v){return v.owner_name===user.name;}) : vulns;
  var breach  = vulns.filter(function(v){return v.days_left<=0&&v.status!=="Remediated";});
  var NAV=[
    {id:"leadership",  label:"Dashboard",        icon:"LayoutDashboard"},
    {id:"vulns",       label:"Vulnerabilities",  icon:"Shield"},
    {id:"remediation", label:"Remediation Plan", icon:"CalendarCheck"},
    {id:"exceptions",  label:"Exceptions",       icon:"ClipboardList"},
    {id:"assets",      label:"Asset Register",   icon:"Monitor"},
    {id:"compliance",  label:"Compliance",       icon:"CheckSquare"},
    {id:"eol",         label:"EOL / EOS Tracker",icon:"AlertTriangle"},
  ];
  NAV.push({id:"settings",   label:"Settings",        icon:"Settings"});
  NAV.push({id:"integrations",label:"Integrations",   icon:"Link2"});
  NAV.push({id:"changepass",label:"Change Password", icon:"Lock"});
    NAV.push({id:"dedup", label:"Dedup & Attack Paths", icon:"GitMerge"});

  if(user.role==="admin"){
    NAV.push({id:"usermgmt",  label:"User Management", icon:"Users"});
    NAV.push({id:"podmgmt",   label:"Pod Management",  icon:"Building2"});
    NAV.push({id:"auditlog",  label:"Audit Log",       icon:"FileText"});
    NAV.push({id:"aiconfig", label:"AI & Config", icon:"Bot"});
    NAV.push({id:"tokenusage", label:"Token Usage",  icon:"BarChart2"});
  }


  var SB_W=collapsed?56:200;
  var curVuln=selVuln?(vulns.find(function(v){return v.id===selVuln.id;})||selVuln):null;
  if(curVuln) return React.createElement(ThemeCtx.Provider,{value:{T:T,name:themeName,toggle:toggle}},React.createElement(VulnDetail,{vuln:curVuln,user:user,onBack:function(){setSelVuln(null);},onUpdate:updateVuln}));

  return React.createElement(ThemeCtx.Provider,{value:{T:T,name:themeName,toggle:toggle}},
    React.createElement("div",{style:{display:"flex",height:"100vh",background:T.bg,fontFamily:"system-ui,sans-serif",color:T.text,overflow:"hidden"}},
      React.createElement("style",null,"@import url('https://fonts.googleapis.com/css2?family=Inter:wght@400;500;600;700;800;900&display=swap');*{box-sizing:border-box;margin:0;padding:0;font-family:Inter,-apple-system,sans-serif}::-webkit-scrollbar{width:3px;height:3px}::-webkit-scrollbar-thumb{background:#A100FF55}::-webkit-scrollbar-thumb:hover{background:#A100FF}@keyframes pulse{0%,100%{opacity:.4;transform:scale(.8)}50%{opacity:1;transform:scale(1)}}@keyframes slideIn{from{transform:translateX(100%);opacity:0}to{transform:translateX(0);opacity:1}}"),

      // Sidebar
      React.createElement("div",{style:{width:SB_W,background:T.sidebar,borderRight:"1px solid "+T.border,display:"flex",flexDirection:"column",flexShrink:0,transition:"width .2s",overflow:"hidden",boxShadow:themeName==="light"?"2px 0 8px rgba(0,0,0,0.06)":"none"}},
        React.createElement("div",{style:{padding:"14px 12px",borderBottom:"1px solid "+T.border,display:"flex",alignItems:"center",gap:10,minHeight:56}},
          React.createElement("div",{style:{width:32,height:32,background:"linear-gradient(135deg,#A100FF,#6600CC)",borderRadius:8,display:"flex",alignItems:"center",justifyContent:"center",flexShrink:0,boxShadow:"0 2px 8px #A100FF44"}},
            React.createElement("svg",{width:18,height:18,viewBox:"0 0 24 24",fill:"none",stroke:"#fff",strokeWidth:2.2,strokeLinecap:"round",strokeLinejoin:"round"},
              React.createElement("path",{d:"M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z"}),
              React.createElement("path",{d:"M9 12l2 2 4-4",stroke:"#fff",strokeWidth:2})
            )
          ),
          !collapsed&&React.createElement("div",null,
            React.createElement("div",{style:{fontSize:13,fontWeight:700,color:T.text,whiteSpace:"nowrap",letterSpacing:.3}},APP_NAME),
            React.createElement("div",{style:{fontSize:9,color:T.accent,fontWeight:600,letterSpacing:1.2,whiteSpace:"nowrap",textTransform:"uppercase"}},"Vuln Management")
          )
        ),
        React.createElement("div",{style:{flex:1,padding:"10px 8px",overflowY:"auto"}},
          NAV.map(function(n){
            return React.createElement("button",{key:n.id,onClick:function(){setPage(n.id);},title:collapsed?n.label:"",style:{width:"100%",display:"flex",alignItems:"center",gap:collapsed?0:9,padding:collapsed?"10px 0":"8px 10px",justifyContent:collapsed?"center":"flex-start",background:page===n.id?"#A100FF15":"transparent",color:page===n.id?"#A100FF":T.text2,borderLeft:page===n.id?"3px solid #A100FF":"3px solid transparent",border:"none",borderRadius:7,cursor:"pointer",fontSize:13,fontWeight:page===n.id?600:400,marginBottom:2,whiteSpace:"nowrap"}},
              React.createElement(Icon,{name:n.icon,size:16}),!collapsed&&React.createElement("span",null,n.label)
            );
          })
        ),
        React.createElement("div",{style:{borderTop:"1px solid "+T.border,padding:"10px 8px"}},
          !collapsed&&React.createElement("div",{style:{display:"flex",alignItems:"center",gap:8,padding:"8px 10px",marginBottom:6}},
            React.createElement(Av,{i:user.avatar||(user.name?user.name.slice(0,2):"?"),s:28,c:user.role==="admin"?"#ef4444":user.role==="lead"?"#6366f1":"#10b981"}),
            React.createElement("div",{style:{flex:1,minWidth:0}},
              React.createElement("div",{style:{fontSize:12,fontWeight:600,color:T.text,overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}},user.name),
              React.createElement("div",{style:{fontSize:10,color:T.accent}},user.role)
            )
          ),
          React.createElement("button",{onClick:toggle,title:themeName==="dark"?"Light mode":"Dark mode",style:{width:"100%",display:"flex",alignItems:"center",gap:8,padding:"7px 10px",justifyContent:collapsed?"center":"flex-start",background:"transparent",color:T.text3,border:"none",borderRadius:6,cursor:"pointer",fontSize:12,marginBottom:2}},
            React.createElement("span",null,themeName==="dark"?"\u2600\uFE0F":"\uD83C\uDF19"),!collapsed&&(themeName==="dark"?"Light mode":"Dark mode")
          ),
          React.createElement("button",{onClick:logout,title:"Sign out",style:{width:"100%",display:"flex",alignItems:"center",gap:8,padding:"7px 10px",justifyContent:collapsed?"center":"flex-start",background:"transparent",color:T.text3,border:"none",borderRadius:6,cursor:"pointer",fontSize:12}},
            React.createElement("span",null,"\uD83D\uDEAA"),!collapsed&&"Sign out"
          ),
          React.createElement("button",{onClick:function(){setCollapsed(function(c){return !c;});},style:{width:"100%",display:"flex",alignItems:"center",gap:8,padding:"7px 10px",justifyContent:collapsed?"center":"flex-start",background:"transparent",color:T.text3,border:"none",borderRadius:6,cursor:"pointer",fontSize:12}},
            React.createElement("span",null,collapsed?"\u203a":"\u2039"),!collapsed&&"Collapse"
          )
        )
      ),

      // Main
      React.createElement("div",{style:{flex:1,display:"flex",flexDirection:"column",overflow:"hidden",minWidth:0}},
        React.createElement("div",{style:{background:T.sidebar,borderBottom:"1px solid "+T.border,padding:"0 16px",display:"flex",alignItems:"center",gap:8,height:52,flexShrink:0}},
          React.createElement("div",{style:{fontSize:14,fontWeight:600,color:T.text,flex:1}},(NAV.find(function(n){return n.id===page;})||{label:"Dashboard"}).label),
          breach.length>0&&page==="dashboard"&&React.createElement("button",{onClick:function(){setPage("vulns");},style:{background:T.danger+"22",color:T.danger,border:"1px solid "+T.danger+"44",borderRadius:7,padding:"4px 10px",cursor:"pointer",fontSize:12,fontWeight:700,flexShrink:0}},"\uD83D\uDD14 "+breach.length+" alerts"),
          
          React.createElement("button",{onClick:function(){setExportOpen(true);},style:{background:T.inset,color:T.text2,border:"1px solid "+T.border,borderRadius:7,padding:"4px 10px",cursor:"pointer",fontSize:12,flexShrink:0}},"\uD83D\uDCE5 Export"),
          can("bulkupload")&&React.createElement("button",{onClick:function(){setNewVulnOpen(true);},style:{background:T.accent,color:"#fff",border:"none",borderRadius:7,padding:"4px 12px",cursor:"pointer",fontSize:12,fontWeight:600,flexShrink:0}},React.createElement("span",{style:{display:"flex",alignItems:"center",gap:4}},React.createElement(Icon,{name:"Plus",size:13}),"New Vuln"))
        ),
                breach.length>0&&React.createElement("div",{style:{background:"#ef444411",borderBottom:"1px solid #ef444433",padding:"6px 16px",display:"flex",alignItems:"center",gap:10,flexShrink:0}},
          React.createElement("div",{style:{width:8,height:8,borderRadius:"50%",background:"#ef4444",flexShrink:0}}),
          React.createElement("span",{style:{fontSize:12,fontWeight:700,color:"#ef4444"}},"SLA Breach"),
          React.createElement("span",{style:{background:"#ef4444",color:"#fff",borderRadius:10,padding:"1px 8px",fontSize:11,fontWeight:700}},breach.length),
          React.createElement("span",{style:{fontSize:11,color:T.text3}},breach.filter(function(v){return v.severity==="Critical";}).length+" critical"),
          React.createElement("button",{onClick:function(){setPage("vulns");},style:{marginLeft:"auto",background:"transparent",border:"1px solid #ef444444",color:"#ef4444",padding:"3px 10px",cursor:"pointer",fontSize:11,fontWeight:600,borderRadius:4}},"View all >")
        ),        React.createElement("div",{style:{flex:1,overflowY:"auto",padding:"16px"}},
          
          page==="vulns"       &&React.createElement(PageVulns,       {user,myVulns,setSelVuln}),
          page==="remediation" &&React.createElement(PageRemediation, {user,myVulns}),
          page==="exceptions"  &&React.createElement(PageExceptions,  {user,vulns}),
          page==="assets"      &&React.createElement(PageAssets,      {user,myVulns}),
          page==="compliance"  &&React.createElement(PageCompliance,  {}),
          page==="eol"         &&React.createElement(PageEOL,         {}),
          page==="leadership"  &&React.createElement(PageLeadership,  {user,myVulns,setExportOpen}),

          page==="settings"    &&React.createElement(PageSettings,   {user}),
          page==="changepass"  &&React.createElement(PageChangePass, {user}),
          page==="dedup"       &&React.createElement(PageDedup,      {user,vulns:myVulns,setPage}),

          page==="usermgmt"    &&React.createElement(PageUserMgmt,  {user}),
          page==="podmgmt"     &&React.createElement(PagePodMgmt,   {user}),
          page==="auditlog"    &&React.createElement(PageAuditLog,  {user}),
          page==="aiconfig"    &&can("aiagent")     &&React.createElement(PageAIConfig,   {vulns,user}),
          page==="integrations"&&React.createElement(PageIntegrations,{myVulns:myVulns,refreshVulns:refreshVulns}),
          page==="tokenusage"  &&React.createElement(PageTokenUsage,{user})
        )
      ),

      exportOpen &&React.createElement(ExportModal, {onClose:function(){setExportOpen(false);},user,myVulns}),
      newVulnOpen&&React.createElement(NewVulnModal,{onClose:function(){setNewVulnOpen(false);},onAdd:addVuln,vulns})
    )
  );
}











